module.exports = __webpack_public_path__ + "img/logo-purple.34967d76.svg";